import { render, staticRenderFns } from "./VehicleInfo.vue?vue&type=template&id=1b145bce&scoped=true"
import script from "./VehicleInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VehicleInfo.vue?vue&type=style&index=0&id=1b145bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b145bce",
  null
  
)

export default component.exports